export const SkeletonMemeArticleCard = () => {
  return (
    <div className='flex flex-col w-full max-w-[383px] rounded-t-xl bg-white text-gray-900 shadow-md border sm:shadow-transparent animate-pulse'>
      <div className='overflow-hidden rounded-t sm:rounded-t-xl bg-gray-200 aspect-video' />
      <div className='flex flex-col gap-3 px-4 py-3 rounded-b-xl'>
        <div>
          <div className='h-4 w-16 bg-gray-200 rounded' />
          <div className='mt-2 h-6 w-3/4 bg-gray-200 rounded' />
        </div>
        <div className='flex flex-row justify-between items-center'>
          <div className='flex flex-row gap-3'>
            <div className='flex gap-1'>
              <div className='flex flex-col gap-1'>
                <div className='h-3 w-20 bg-gray-200 rounded' />
                <div className='h-3 w-16 bg-gray-200 rounded' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
